/**
 * Checking and update height of Text Slide in Flickity
 */
/* eslint-disable no-underscore-dangle */
const Flickity = require('flickity');

Flickity.createMethods.push('_createPluginMdsTextSlide');

const proto = Flickity.prototype;

proto._createPluginMdsTextSlide = function createPluginMdsTextSlide() {
  let textSlideEl = null;
  this.on('ready', () => {
    textSlideEl = this.element.querySelector('.js-text-slide');
  });

  const updateHeight = () => {
    if (textSlideEl) {
      textSlideEl.style.minHeight = `${this.maxCellHeight}px`;
    }
  };
  updateHeight();
  this.on('resize', updateHeight);
};
